var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01389 16.5L1.44639 10.05C0.698779 9.1673 0.217327 8.09037 0.0581096 6.94462C-0.101107 5.79887 0.0684637 4.63147 0.547074 3.57837C1.02568 2.52527 1.79364 1.62981 2.76149 0.996293C3.72934 0.362774 4.85727 0.017263 6.01389 0C7.6172 0.0158439 9.14888 0.666445 10.2735 1.80931C11.3981 2.95218 12.0239 4.49415 12.0139 6.0975C12.0145 7.4962 11.5383 8.85333 10.6639 9.945L6.01389 16.5ZM6.01389 1.5C4.80778 1.51385 3.65647 2.00578 2.81275 2.86778C1.96904 3.72978 1.50189 4.89137 1.51389 6.0975C1.51892 7.19837 1.91498 8.26163 2.63139 9.0975L6.01389 13.89L9.48639 9C10.1465 8.17608 10.5086 7.1532 10.5139 6.0975C10.5259 4.89137 10.0588 3.72978 9.21504 2.86778C8.37132 2.00578 7.22 1.51385 6.01389 1.5Z",
    fill: "#178477"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01392 6.75C6.84234 6.75 7.51392 6.07843 7.51392 5.25C7.51392 4.42157 6.84234 3.75 6.01392 3.75C5.18549 3.75 4.51392 4.42157 4.51392 5.25C4.51392 6.07843 5.18549 6.75 6.01392 6.75Z",
    fill: "#178477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLocation);
export default __webpack_public_path__ + "static/media/profile-location.73af969d9a4405c1f8499691d8967dda.svg";
export { ForwardRef as ReactComponent };